import regexExps from "@/config/regexExps";

export default function isValidSsn(ssnData: string) {
  const ssnFormat = new RegExp(regexExps.ssn);

  return ssnFormat.test(ssnData);
}
